import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Slider from "react-slick";
import icreatelogo from '../assets/images/icreatelogo.png';

// import logo from '../assets/images/logo.png'
import author1 from "../assets/images/blog/author-1.jpg";
import author2 from "../assets/images/blog/author-2.jpg";
import author3 from "../assets/images/blog/author-3.jpg";
import author4 from "../assets/images/blog/author-4.jpg";
// import author5 from "../assets/images/blog/author-5.jpg";
import axios from "axios";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import "../assets/css/style.css";
import DigitalRaizpdf from "../assets/images/newimgs/1. Company Profile Final One.pdf";
import DigitalraizPvt from "../assets/images/newimgs/digitalraiz comany portfilo.pdf";
import { NavLink, useNavigate } from "react-router-dom";
import { PlayCircle } from '@mui/icons-material';

function Header() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [form, setform] = useState({
    name: "",
    phone:"",
    email: "",
    Courses: "BBA",
    location: ""
  });


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [sticky, setSticky] = useState("");


  useEffect(() => {
    const find = localStorage.getItem("finds")
    if (find == null) {
      handleShow();
    }

    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);

    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 200 ? "header-area sticky" : "";
    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const classes = `${sticky}`;


  return (
    <div>
      <header className={classes} id="header-area">
        <nav className="navbar navbar-expand-md fixed-top">
          <div className="container">
            <div className='row' style={{ width: "100%" }}>
              <div className='col-3'>

                <div className="pict"><NavLink to="/" className="navbar-brand" >
                  <img src={icreatelogo} className="img-fluid moblogoimg" alt="Img" id='pict' width={150} />
                </NavLink></div>
              </div>
              <div className='col-9'>
                {/* <a className="btn themes-btn btn-block headbtn" style={{border:"none",background:"none"}}><a  className=''><i class="fa fa-phone mr-1" aria-hidden="true"></i>+91 9494613601</a></a> */}
                <div className='headtab' style={{ float: "right" }}>

                  {/* <p> <i class="fa fa-phone mr-1" aria-hidden="true"></i>+91 9494613601</p> */}
                  <div className='row mt-3 mobtab' >
                    <div className='col-4 mobileslider' style={{ marginTop: "10px" }}>
                      <a href='tel:+91 83 67 215 215' className='contactnumber '> <i class="fa fa-phone mr-1 " aria-hidden="true"></i>+91 83 67 215 215</a>
                    </div>

                    <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 headerbtnsm'>

                      <div className="control-form">
                        <a href='https://www.instagram.com/icreate12/' target="_blank">
                          <button className="btn themes-btn btn-block headbtn" id='btn2'><a className='btna'>icreate12 <i class="fa fa-instagram" aria-hidden="true"></i></a></button>
                        </a>
                      </div>


                    </div>

                    <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4'>
                      <div className="control-form btnmar ">
                        <a href='https://www.icreateedu.in/' target="_blank">
                          <button className="btn theme-btn btn-block headbtn1"><span className='btna text-white' >www.icreateedu.in<i class="fa fa-arrow-right ml-1" aria-hidden="true"></i></span></button>
                        </a>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </nav>

      </header>

      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  )
}

export default Header